<template>
    <div class="container storefront-container mx-auto">
        <UploadModal
            v-if="user && owner"
            :modalVisible="uploadModalShown"
            :modalType="uploadModalType"
            @uploadModalClosed="uploadModalClosed"
            :organization="organization"
        />

        <CreatePingModal
            v-if="user && owner && !pingingMember"
            :mentionableUsers="[]"
            :modalVisible="pingModalShown"
            v-on:modalHidden="onModalHidden"
            :isStoreFront="true"
            :isOrganizationPost="true"
            :organization="organization"
            :isPost="isModalForPost"
            :userId="this.user.id"
            :maxContentLength="5000"
        />

        <CreatePingModal
            v-show="pingingMember"
            :modalVisible="pingModalShown"
            v-on:modalHidden="onModalHidden"
            :mentionableUsers="[]"
            :userId="user? user.id: null"
            :isPost="isModalForPost"
            :prePopulatedMentionedUser="pingModalMentionedUser"
            :maxContentLength="1000"
        />

        <ShareModal
            v-show="sharingMember"
            :modalVisible="shareModalShown"
            :mentionableUsers="[]"
            v-on:modalHidden="onModalHidden"
            :sharedUser="shareModalMentionedUser"
            :userId="user? user.id: null"
        />

        <Header
            :isOrgOwner="this.owner"
            :organization="organization"
            @showUploadModal="showUploadModal"
        />

        <!-- Start button section -->
        <div class="flex">
            <div class="w-1/3 flex justify-start items-center">
                <h2 class="text-2xl mr-2">
                    {{ organization.dba? organization.dba : organization.name }}
                </h2>
            </div>
                <p class="-ml-28 md:ml-0 left-0 invisible md:visible sm:w-full content-center">
                    About us:
                    <span v-if="editingDescription">
                        <textarea
                            rows="3"
                            cols="60"
                            maxlength="250"
                            class="rounded-lg w-5/6 ml-4"
                            placeholder="Enter the description for the Organization page"
                            v-model="organization.description"
                        />
                        <button
                            type="button"
                            @click="submitDescription()"
                            class="flex mx-auto mt-11 pl-5 text-white storefront-btn-blue font-medium rounded-lg text-sm px-5 py-2.5 mr-7 mb-2 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                        >
                            <svg-vue
                                v-if="descriptionSaving"
                                icon="loader"
                                title="Saving"
                            />
                    Save
                </button>
                    </span>
                    <span v-else>
                        {{ organization.description ? organization.description : "Coming Soon"}}
                    </span>
                    <a
                        v-if="owner"
                        class="flex ml-2"
                        @click="toggleEditingDescription()"
                    >
                        <svg-vue
                            v-if="!editingDescription"
                            icon="pencil-solid"
                            title="about icon"
                            class="w-5 h-5 fill-black"
                        />
                    </a>
                </p>
            <div class="w-1/3"></div>
            <div class="w-1/3 flex justify-start">
                <p class="-ml-28 md:ml-0 left-0 invisible md:visible sm:w-full"
                   v-if="!user">
                    Login or Register to interact with these Pros, and reload this page. Your information will remain private.
                </p>
                <a
                    v-if="user == null"
                    class="primary-btn rounded-lg px-4 text-white no-underscore text-base h-16 pt-1"
                    type="button"
                    href="/login"
                    target="_blank"
                >
                    Login or Signup
                </a>
                <button
                    v-if="owner"
                    class="primary-btn rounded-lg px-4 text-white"
                    type="button"
                    @click="handleAddPostClick"
                >
                    Add Post
                </button>
                <button
                    class="primary-btn rounded-lg px-4 text-white"
                    v-if="
                        user &&
                        !owner &&
                        !showSuccessJoin &&
                        !showErrorJoin &&
                        !isMember
                    "
                    @click="requestToJoin"
                    :disabled="joinIsSaving"
                >
                    Join
                </button>
                <t-alert variant="success" :show="showSuccessJoin">
                    Join request sent successfully!
                </t-alert>
                <t-alert
                    variant="danger"
                    :show="showErrorJoin"
                    @hidden="showErrorJoin= false"
                >
                    Join request failed! Please contact the organization's
                    admin.
                </t-alert>
                <button
                    class="primary-btn rounded-lg px4 text-white ml-2"
                    v-if="user &&
                          !owner &&
                          !showSuccessFollow &&
                          !showErrorFollow &&
                          !isFollowing &&
                          !isMember
                          "
                    @click="follow"
                    :disabled="followIsSaving"
                    >
                    <svg-vue
                        icon="bookmark"
                        title="Bookmark"
                        class="h-6 mr-1 fill-white"
                        @click.prevent="follow"
                    />
                </button>
                <t-alert variant="success" :show="showSuccessFollow">
                    Follow request sucessful!
                </t-alert>
                <t-alert
                    variant="danger"
                    :show="showErrorFollow"
                    @hidden="showErrorFollow = false"
                >
                    Follow request failed! Please contact the organization's
                    admin.
                </t-alert>
            </div>
        </div>
        <!-- End button section -->

        <div class="mt-8 grid grid-cols-8 gap-x-4 content-wrapper">
            <div class="pt-6 col-span-2" v-if="owner">
                <member-request-list
                    class="w-11/12"
                    :requests="memberRequests"
                    :organization="organization"
                    :user="user"
                />
            </div>

            <div
                class="justify-start"
                :class="this.owner ? 'col-span-4' : 'col-span-5'"
            >
                <pros-table :user="user"
                            :filters="filters"
                            :pros="members"
                            :industries="industries"
                            :professions="professions"
                            :organization="organization"
                            :search_options="searchOptions"
                            :sortOrder="sortOrder"
                            :radius="radius"
                            :radius_choices="radiusChoices"
                            :initially-premium="initiallyPremium"
                            v-on:openPingModal="showPingModal"
                            v-on:openShareModal="showShareModal"
                            :with-submit="true"/>
            </div>

            <!-- Section here for organization posts -->
            <div
                class="h-1/2 pt-4"
                :class="
                    !this.owner
                        ? ['col-span-3']
                        : [
                              'col-span-2',
                              // 'col-start-4',
                              'w-full',
                              'pt-4',
                              'text-xl',
                          ]
                "
            >
                <organization-posts-list :posts="posts" />
            </div>
        </div>

        <!-- End content section -->
    </div>
</template>

<script>
import Header from "./partials/Header.vue";
import ProsTable from "../Search/partials/ProsTable";
import OrganizationProsTable from "./partials/OrganizationProsTable.vue";
import OrganizationPostsList from "./partials/OrganizationPostsList.vue";
import MemberRequestList from "./partials/MemberRequestList.vue";
import CreatePingModal from "../Ping/CreatePingModal.vue";
import ShareModal from "./partials/ShareModal.vue";
import UploadModal from "./partials/UploadModal.vue";
import MemberRequestButton from "./partials/MemberRequestButton.vue";

export default {
    mounted() {
        console.log( 'organization:');
        console.log( this.organization);
        console.log( 'index: members');
        console.log( 'sort order');
        console.log( this.sortOrder);
        this.displayedMembers = this.members;
        console.log( this.displayedMembers);
    },
    data() {
        return {
            recommendedProPicks: [],
            hours: {},
            pingModalShown: false,
            pingModalMentionedUser: null,
            shareModalShown: false,
            shareModalMentionedUser: null,
            connectedData: this.connected,
            connectionSaving: false,
            isOwnStorefront: this.editable,
            isModalForPost: false,
            uploadModalShown: false,
            uploadModalType: "avatar",
            showSuccessJoin: false,
            showErrorJoin: false,
            joinIsSaving: false,
            showSuccessFollow: false,
            showErrorFollow: false,
            followIsSaving: false,
            aboutSaving: false,
            pingingMember: false,
            sharingMember: false,
            displayedMembers: [],
            searchOptions: ["text", "industry", "profession", "walkins", "location", "sort"],
            radiusChoices: ["5mi", "10mi", "25mi", "50mi", "200mi", "500mi", "1000mi","5000mi"],
            initiallyPremium: true,
            editingDescription: false,
            descriptionSaving: false,
        };
    },
    props: [
        "organization",
        "owner",
        "industries",
        "professions",
        "memberRequests",
        "user",
        "posts",
        "filters",
        "isMember",
        "isFollowing",
        "members",
        "sortOrder",
        "radius",
    ],
    computed: {
        connectionStatus() {
            if (this.connectedData === true) {
                return "Already Connected";
            } else if (this.connectedData === "pending") {
                return "Pending";
            } else if (this.connectedData === "waiting") {
                return "Accept pending request";
            } else {
                return "Connect";
            }
        },
    },
    methods: {
        showUploadModal(uploadType) {
            this.uploadModalType = uploadType;
            this.uploadModalShown = true;
        },
        onModalHidden() {
            this.pingingMember = false;
            this.isModalForPost = true;
            this.pingModalMentionedUser  = null;
            this.pingModalShown = false;
            this.shareModalShown = false;
        },
        uploadModalClosed() {
            this.uploadModalShown = false;
        },
        showPingModal(member){
            this.pingModalMentionedUser = member;
            this.pingingMember = true;
            this.isModalForPost = false;
            this.pingModalShown = true;
        },
        showShareModal( member){
            this.shareModalMentionedUser = member;
            this.sharingMember = true;
            this.isModalForPost = false;
            this.shareModalShown = true;
        },
        handleAddPostClick() {
            this.isModalForPost = true;
            this.pingModalShown = true;
        },
        requestToJoin() {
            this.joinIsSaving = true;
            axios
                .post(`/api/organizations/${this.organization.id}/join`)
                .then(() => {
                    this.showSuccessJoin = true;
                })
                .catch((error) => {
                    console.log(error);
                    this.showErrorJoin = true;
                })
                .finally(() => {
                    this.joinIsSaving = false;
                });
        },
        follow() {
            this.followIsSaving = true;
            axios
                .post( '/api/organizations/' + this.organization.id + '/follow')
                .then(()=> { this.showSuccessFollow = true})
                .catch( (error) => {
                    console.log( error);
                    this.showErrorFollow = true;
                })
                .finally( () => {
                    this.followIsSaving = false;
                });
        },
        reloadFeed(){
            console.log( 'reloading feed in org/index.vue');
            axios.get(`/organizations/${this.organization.id}/memberFeed`)
                .then(response => {
                    this.displayedMembers = response.data;
                    console.log( 'reload:');
                    console.log( this.displayedMembers);
                })
                .catch(error =>{
                    console.log(error);
                })
        },
        toggleEditingDescription(){
            this.editingDescription = !this.editingDescription;
        },
        async submitDescription() {
            this.aboutSaving = true;
            this.editingDescription = false;
            await axios
                .post('/api/organizations/' + this.organization.id + '/store', {
                    description: this.organization.description
                })
                .then((response) => {
                    this.descriptionSaving = false;
                    this.$toasted.global.toast_success('Save Successful');
                })
                .catch((error) => {
                    console.log(error);
                    alert("something went wrong!");
                });
        },
    },
    components: {
        Header,
        ProsTable,
        OrganizationProsTable,
        OrganizationPostsList,
        MemberRequestList,
        CreatePingModal,
        ShareModal,
        UploadModal,
        MemberRequestButton,
    },
};
</script>

<style scoped>
.button-row {
    margin-top: -25px;
}

.name-box {
    margin-top: -3rem;
    z-index: -1;
}

.pro-link-button svg {
    margin-top: 2px;
}
</style>
